import React from 'react';
import {connect} from "react-redux";
import Track from './Track';
import Media from "../../dataModel/Media";
import Link from "./Link";
import RelatedObjectList from "./RelatedObjectList";
import MediaControl from "./MediaControl";
import Localization from "../../localization";
import InfoManager from "../../managers/InfoManager";


export class MediaList extends React.Component {

    static instance;


    state = {
        isPlaying: false,
        playingId: null
    };


    componentDidMount() {
        MediaList.instance = this;
    }


    isPlaying(isPlaying = false, playingId = null) {
        // for controlling buttons icon
        // console.log(isPlaying ? 'start' : 'stop');
        if (isPlaying && playingId === true) {
            this.setState({isPlaying});
            return;
        }
        this.setState({isPlaying, playingId});
    }


    render() {
        const {mediaEntries = []} = this.props.object || {};
        const {selectedLanguage, mediaProgress} = this.props;

        const soundtrackList = mediaEntries.filter(item =>
            item.isSpeak && !item.isSubTrack
            && (item.language === selectedLanguage || !selectedLanguage || item.language === "independent" || item.ignoreLang));
        const hasSoundtrack = soundtrackList.length > 0;

        const foundLinks = {}; // {[LinkType]: language, ...}
        const linkList = mediaEntries
            .filter(
                item => {
                    const pass = item.isLink
                        && (item.language === selectedLanguage || !selectedLanguage || item.ignoreLang)
                        && (!foundLinks[item.linkType] || foundLinks[item.linkType] === item.language)

                    if (pass) {
                        foundLinks[item.linkType] = item.language
                    }

                    return pass;
                }
            );
        const hasLink = linkList.length > 0;

        const textDocList = mediaEntries.filter(it =>
            it.isTextDoc && (it.language === InfoManager.currentLanguage || it.ignoreLang) && it.textData);
        const hasTextDoc = textDocList.length > 0;

        return (
            <>
                {
                    hasTextDoc &&
                        <div className="TextDocContainer">
                            {textDocList.map(textDoc => (
                                <div className="TextDocItem" key={textDoc.mediaId}>
                                    <h3>{textDoc.getDescription}</h3>

                                    {textDoc.textData}
                                </div>
                            ))}
                        </div>
                }

                {
                    hasSoundtrack &&
                    <MediaControl
                        object={this.props.object}
                        objectList={this.props.objectList}
                        selectedLanguage={selectedLanguage}
                        mediaProgress={mediaProgress}
                        isPlaying={this.props.isPlaying}
                        playingId={this.state.playingId}/>

                }

                {
                    soundtrackList.length > 1 &&
                    <>
                        <div className="ContentDelimiter heavyText">
                            {Localization.stringFor("listenMoreAboutObject")}
                        </div>

                        <div className="tracksContainer">
                            {
                                soundtrackList
                                    // .sort(Media.sortFunction)
                                    .map(parentTrack => {
                                        const subTrackList = Media.sortByPrefPrevTag([...mediaEntries]
                                            .filter(item => item.isSpeak && item.isChildOf(parentTrack)));

                                        return (
                                            <Track track={parentTrack}
                                                   subTracks={subTrackList}
                                                   playingId={this.state.playingId}
                                                   selectedLanguage={selectedLanguage}
                                                   key={parentTrack.mediaId}/>
                                        )
                                    })
                            }
                        </div>
                    </>
                }

                {
                    (this.props.object && this.props.object.childrenList) &&
                    <div className="ContentDelimiter heavyText">
                        Contents
                    </div>
                }

                <div className="tracksContainer">
                    <RelatedObjectList object={this.props.object} />
                </div>



                {
                    hasLink &&
                    <div className="ContentDelimiter heavyText">
                        {Localization.stringFor("learnMoreAboutObject")}
                    </div>
                }

                <div className="tracksContainer">
                    {
                        linkList
                            .map(media => <Link media={media} key={media.mediaId}/>)
                    }
                </div>

            </>
        );
    }
}


const mapStateToProps = ({object, selectedLanguage, mediaProgress, isPlaying, objectList}) => ({object, selectedLanguage, mediaProgress, isPlaying, objectList});
export default connect(mapStateToProps)(MediaList);
